import React from 'react';
import {NodeProps} from 'reactflow';

import BenchlingNode from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNode';

export default function RouterNodeRenderer(props: NodeProps): JSX.Element {
  return (
    <BenchlingNode
      {...props}
      data={{
        nodeName: 'Router',
        sections: [],
        nodeIcon: 'diamond',
        rowRenderer: () => null,
        hideSectionSummaries: true,
      }}
    />
  );
}
